import { StrapiCollectionType } from "@/src/type";

interface GetSchemaProps {
  property?: StrapiCollectionType.Property;
  name: string;
  headline: string;
  url: string;
  image: string;
  description: string;
  domain: string;
}

function getSchema({ property, name, headline, url, image, description, domain }: GetSchemaProps): any {
  if (property) {
    const amenityFeature = (property.features ?? []).map((feature) => {
      return {
        "@type": "LocationFeatureSpecification",
        name: feature.title,
        value: true,
      };
    });

    return {
      "@context": "https://schema.org",
      "@type": "ApartmentComplex",
      name: property.name,
      description: property.description ?? description,
      url: `${domain}/properties/${property.slug}`,
      telephone: `+${property.countryCode ?? "1"}${property.phoneNumber}`,
      address: {
        "@type": "PostalAddress",
        streetAddress: property.address?.address1,
        addressLocality: property.address?.city,
        addressRegion: property.address?.state,
        postalCode: property.address?.zip,
        addressCountry: property.address?.countryAbbrv,
      },
      amenityFeature: amenityFeature,
      petsAllowed: true,
      tourBookingPage: `${domain}/properties/${property.slug}/schedule-tour`,
    };
  }

  return {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: name,
    alternateName: [name],
    headline: headline,
    url: url,
    image: [image],
    description: description,
  };
}

function getHomeCanonical(path: string, locale: string, propertySlug?: string) {
  if (locale === "en" && !propertySlug) {
    if (path === "home" || path === "/home") {
      return "/";
    }
  } else if (propertySlug) {
    if (path === "home" || path === "/home") {
      return `/property/${propertySlug}`;
    }
    return `/property/${propertySlug}/${path}`;
  }
  return path;
}

export default {
  getSchema,
  getHomeCanonical,
};
